import { render, staticRenderFns } from "./Pagesat.vue?vue&type=template&id=85070360"
import script from "./Pagesat.vue?vue&type=script&lang=js"
export * from "./Pagesat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports